import * as tf from '@tensorflow/tfjs'
import { KNeighborsRegressor, setBackend } from '@/vendor/scikitjs/dist/es5'
import $ from 'jquery'

export default class NeuralToneAI {
    constructor() {
        setBackend(tf)

        this.blockName = 'NeuralToneAI'
        this.version = '1.0.0'

        this.curveNames = ['WhiteBalance-R', 'WhiteBalance-G', 'WhiteBalance-B', 'Tint-R', 'Tint-G', 'Tint-B']
        this.img_size = 64
        this.lut_size = 8

        this.passNamesList = [
            'EXPOSURE',
            'CONTRAST',
            'WHITE BALANCE',
            'TINT',
            'AI PREDICTION LUT',
            'CREATIVE LUT'
        ]

        this.modelNamesList = [
            'Chromia',
            'Mystera',
            'Solstice',
            'Aura',
            'Mythra',
            'Mariposa',
            'Seraphine',
            'Magnolia'
        ]

        this.models = [
            {
                name: 'Mystera',
                file: null
            },
            {
                name: 'Chromia',
                file: null
            },
            {
                name: 'Chromia',
                file: null
            },
            {
                name: 'Mystera',
                file: null
            },
            {
                name: 'Mythra',
                file: null
            },
            {
                name: 'Mythra',
                file: null
            },
            {
                name: 'Seraphine',
                file: null
            },
            {
                name: 'Seraphine',
                file: null
            },
        ]

        this.exposure = {
            minValue: -5,
            maxValue: 5
        }

        this.contrast = {
            minValue: -1,
            maxValue: 1,
        }

        this.whiteBalance = {
            minValue: -4000,
            maxValue: 4000,
            calcValue: 8000,
        };

        this.tint = {
            minValue: -100,
            maxValue: 100,
            calcValue: 100,
        };

        this.opacity = {
            minValue: 0,
            maxValue: 100,
        }
    }

    async addBlock(blockNum = lutify.blocks.length, data = { initial: true }) {
        UI.createAdjustmentBlockTemplate('neural-tone-ai', blockNum)
        let element = UI.getAdjustmentBlock(blockNum)
        this.addRegenerateButton($(element))
        UI.removeBlockBlendingModes($(element))

        UI.appendBlockLoadingSpinner($(element))

        if (data.initial) {
            if (!data.multiProcess) {
                UI.showModal(UI.modals.neuralToneAI.processing.el)
                vm.$store.commit('UI/SET_NEURAL_TONE_AI_PROCESSING_STEP', 1)
            }

            UI.togglePreviewsContainer()
            lutPreviewer.showPlaceholderPreviews()
        }

        await this.loadModel()
        await this.loadLuts()

        $(element)
            .find('.expand_options')
            .trigger('click', [false])

        $(element).on('click', e => {
            e.stopImmediatePropagation()

            // UI.hideLUTtemplates()
            // UI.deselectPreview()

            if (!luts['LUTcontrols'][`NeuralToneAI`]) return
            if (luts['LUTcontrols'][`NeuralToneAI`].length == 0) return

            this.showPreviews()

            if (!lutify.getActiveBlock().presetId) return
            let preset = luts['LUTcontrols'][`NeuralToneAI`][lutify.getActiveBlock().presetId]
            this.onPresetSelection(preset)
        })

        $(element)
            .find('.exposure_slider')
            .on('input', () => {
                blocks.checkSwitchHandler($(element));
                lutify.getActiveBlock().passes[this.passNamesList.indexOf('EXPOSURE')].enabled = true;

                let exposureValue = UI.getAdjustmentBlock_sliderValue($(element), 0);
                UI.setAdjustmentBlock_rangeValue($(element), exposureValue, 0);

                let block = lutify.getActiveBlock();
                block.values.exposure = exposureValue;
                block.passes[this.passNamesList.indexOf('EXPOSURE')].uniforms.exposure.value = exposureValue;
                gpu.render();
            })

        $(element)
            .find('.exposure_range')
            .on('change', () => {
                blocks.checkSwitchHandler($(element));
                lutify.getActiveBlock().passes[this.passNamesList.indexOf('EXPOSURE')].enabled = true;

                let exposureValue = UI.getAdjustmentBlock_rangeValue($(element), 0);

                if (exposureValue > this.exposure.maxValue) {
                    exposureValue = this.exposure.maxValue;
                    UI.setAdjustmentBlock_rangeValue($(element), exposureValue, 0);
                }
                if (exposureValue < this.exposure.minValue) {
                    exposureValue = this.exposure.minValue;
                    UI.setAdjustmentBlock_rangeValue($(element), exposureValue, 0);
                }

                UI.setAdjustmentBlock_sliderValue($(element), exposureValue, 0);
                lutify.getActiveBlock().values.exposure = exposureValue;
                lutify.getActiveBlock().passes[this.passNamesList.indexOf('EXPOSURE')].uniforms.exposure.value = exposureValue;
                gpu.render();
            })

        $(element)
            .find('.contrast_slider')
            .on('input', () => {
                blocks.checkSwitchHandler($(element));
                lutify.getActiveBlock().passes[this.passNamesList.indexOf('CONTRAST')].enabled = true;

                let contrastValue = UI.getAdjustmentBlock_sliderValue($(element), 1);
                UI.setAdjustmentBlock_rangeValue($(element), contrastValue, 1);

                let block = lutify.getActiveBlock();
                block.values.contrast = contrastValue;
                lutify.getActiveBlock().passes[this.passNamesList.indexOf('CONTRAST')].uniforms.contrast.value = contrastValue;
                gpu.render();
            })

        $(element)
            .find('.contrast_range')
            .on('change', () => {
                blocks.checkSwitchHandler($(element));
                lutify.getActiveBlock().passes[this.passNamesList.indexOf('CONTRAST')].enabled = true;

                let contrastValue = UI.getAdjustmentBlock_rangeValue($(element), 1);

                if (contrastValue > this.contrast.maxValue) {
                    contrastValue = this.contrast.maxValue;
                    UI.setAdjustmentBlock_rangeValue($(element), contrastValue, 1);
                }
                if (contrastValue < this.contrast.minValue) {
                    contrastValue = this.contrast.minValue;
                    UI.setAdjustmentBlock_rangeValue($(element), contrastValue, 1);
                }

                UI.setAdjustmentBlock_sliderValue($(element), contrastValue, 1);
                lutify.getActiveBlock().values.contrast = contrastValue;
                lutify.getActiveBlock().passes[this.passNamesList.indexOf('CONTRAST')].uniforms.contrast.value = contrastValue;
                gpu.render();
            })

        $(element)
            .find('.white_balance_slider')
            .on('input', () => {
                blocks.checkSwitchHandler($(element));
                lutify.getActiveBlock().passes[this.passNamesList.indexOf('WHITE BALANCE')].enabled = true;

                let whiteValue = UI.getAdjustmentBlock_sliderValue($(element), 2);
                UI.setAdjustmentBlock_rangeValue($(element), whiteValue, 2);

                let block = lutify.getActiveBlock();
                block.values.whiteBalance = whiteValue;
                this.curveWBalance(block.values.whiteBalance);
            })

        $(element)
            .find('.white_balance_range')
            .on('change', () => {
                blocks.checkSwitchHandler($(element));
                lutify.getActiveBlock().passes[this.passNamesList.indexOf('WHITE BALANCE')].enabled = true;

                let whiteValue = UI.getAdjustmentBlock_rangeValue($(element), 2);

                if (whiteValue > this.whiteBalance.maxValue || whiteValue < this.whiteBalance.minValue) {
                    if (whiteValue < this.whiteBalance.minValue) {
                        whiteValue = this.whiteBalance.minValue;
                        UI.setAdjustmentBlock_rangeValue($(element), whiteValue, 2);
                    } else {
                        whiteValue = this.whiteBalance.maxValue;
                        UI.setAdjustmentBlock_rangeValue($(element), whiteValue, 2);
                    }
                }

                UI.setAdjustmentBlock_sliderValue($(element), whiteValue, 2);
                lutify.getActiveBlock().values.whiteBalance = whiteValue;
                this.curveWBalance(lutify.getActiveBlock().values.whiteBalance);
            })

        $(element)
            .find('.tint_slider')
            .on('input', _ => {
                blocks.checkSwitchHandler($(element));
                lutify.getActiveBlock().passes[this.passNamesList.indexOf('TINT')].enabled = true;

                let tintValue = UI.getAdjustmentBlock_sliderValue($(element), 3);
                UI.setAdjustmentBlock_rangeValue($(element), tintValue, 3);

                let block = lutify.getActiveBlock();
                block.values.tint = tintValue / this.tint.calcValue;
                this.curveTint(block.values.tint);
            })

        $(element)
            .find('.tint_range')
            .on('change', _ => {
                blocks.checkSwitchHandler($(element));
                lutify.getActiveBlock().passes[this.passNamesList.indexOf('TINT')].enabled = true;

                var tintValue = UI.getAdjustmentBlock_rangeValue($(element), 3);

                if (tintValue > this.tint.maxValue) {
                    tintValue = this.tint.maxValue;
                    UI.setAdjustmentBlock_rangeValue($(element), tintValue, 3);
                }
                if (tintValue < this.tint.minValue) {
                    tintValue = this.tint.minValue;
                    UI.setAdjustmentBlock_rangeValue($(element), tintValue, 3);
                }

                UI.setAdjustmentBlock_sliderValue($(element), tintValue, 3);
                lutify.getActiveBlock().values.tint = tintValue / this.tint.calcValue;
                this.curveTint(lutify.getActiveBlock().values.tint);
            })

        $(element).find('.opacity_slider').on('input', () => this.opacitySliderHandler($(element)))
        $(element).find('.opacity-input').on('change', () => this.opacityInputHandler($(element)))

        $(element)
            .find('.btn-reset-block')
            .on('click', e => {
                e.stopPropagation()
                this.resetBlock($(element))
            })

        $(element).find('.sample-selector').on('click', e => {
            document.getElementById('previews-list-container')._tippy.show()
            setTimeout(() => {
                document.getElementById('previews-list-container')._tippy.hide()
            }, 5000)

        })

        UI.initKnob(element, {
            size: 30,
        })

        blocks.add({
            name: this.blockName,
            version: this.version,
            passes: this.addPasses(),
            curves: [],
            predictions: [],
            predictionsContent: [],
            presetId: null,
            blockNum,
            blendingMode: 0,
            blendingModeName: 'Normal',
            opacity: 100,
            values: {
                exposure: 0,
                contrast: 0,
                whiteBalance: 0,
                tint: 0,
            }
        })

        if (data.initial) {
            vm.$store.commit('UI/SET_NEURAL_TONE_AI_PROCESSING_STEP', 2)

            await new Promise(resolve => {
                setTimeout(() => {
                    vm.$store.commit('UI/SET_NEURAL_TONE_AI_PROCESSING_STEP', 3)
                    resolve()
                }, 300)
            })
        }

        if (data.initial) await this.predictAll()
        else await this.applyPredictions(data.predictionsContent)

        if (data.initial) {
            vm.$store.commit('UI/SET_NEURAL_TONE_AI_PROCESSING_STEP', 4)

            await new Promise(resolve => {
                setTimeout(() => {
                    if (!data.multiProcess) UI.hideModal()
                    resolve()
                }, 300)
            })
        }

        blocks.createCurves(this.curveNames, blockNum)

        // this.setPresetList(luts["LUTcontrols"]["NeuralToneAI"]);

        // vm.$store.dispatch("Loader/showProgressBar", false);
        UI.removeBlockLoadingSpinner($(UI.getActiveBlock()))
        lutPreviewer.removePlaceholderPreviews()

        $(element).find('.controls-wrapper .switch input').trigger('click')
    }

    curveWBalance(wbValue) {
        let curveR = lutify.getActiveBlock().curves[0].colorCurve;
        let curveG = lutify.getActiveBlock().curves[1].colorCurve;
        let curveB = lutify.getActiveBlock().curves[2].colorCurve;

        curveR.points = [];
        curveG.points = [];
        curveB.points = [];

        if (wbValue >= 0) {
            curveR.points.push({ x: 0.0, y: 0.0 + wbValue * 0.00001569 });
            curveR.points.push({ x: 1.0 - wbValue * 0.00001472, y: 1.0 });

            curveG.points.push({ x: 0.0, y: 0.0 + wbValue * 0.00000784 });
            curveG.points.push({ x: 1.0, y: 1.0 - wbValue * 0.00000784 });

            curveB.points.push({ x: 0.0, y: 0.0 + wbValue * 0.0000155 });
            curveB.points.push({ x: 0.188, y: 0.188 - wbValue * 0.00001175 });
            curveB.points.push({ x: 1.0, y: 1.0 - wbValue * 0.00002275 });
        } else if (wbValue < 0) {
            curveR.points.push({ x: 0.0 + Math.abs(wbValue) * 0.00001569, y: 0.0 });
            curveR.points.push({ x: 1.0, y: 1.0 - Math.abs(wbValue) * 0.00001472 });

            curveG.points.push({ x: 0.0 + wbValue * 0.00000784, y: 0.0 });
            curveG.points.push({ x: 1.0 - wbValue * 0.00000784, y: 1.0 });

            curveB.points.push({ x: 0.0 + Math.abs(wbValue) * 0.00001569, y: 0.0 });
            curveB.points.push({ x: 0.188, y: 0.188 + Math.abs(wbValue) * 0.00002163 });
            curveB.points.push({ x: 0.25, y: 0.25 + Math.abs(wbValue) * 0.00002672 });
            curveB.points.push({ x: 0.376, y: 0.376 + Math.abs(wbValue) * 0.00003247 });
            curveB.points.push({ x: 0.5, y: 0.5 + Math.abs(wbValue) * 0.00003382 });
            curveB.points.push({ x: 1.0 - Math.abs(wbValue) * 0.00002275, y: 1.0 });
        }

        curveR.draw();
        curveG.draw();
        curveB.draw();
        curveR.updateValues();
        curveG.updateValues();
        curveB.updateValues();

        let curveTexture = gpu.RGBPointsToCurve(curveR.rgb, curveG.rgb, curveB.rgb);
        lutify.getActiveBlock().passes[this.passNamesList.indexOf('WHITE BALANCE')].uniforms["map"].value = curveTexture;
        gpu.render();
    }

    curveTint(tintValue) {
        let curveR = lutify.getActiveBlock().curves[3].colorCurve;
        let curveG = lutify.getActiveBlock().curves[4].colorCurve;
        let curveB = lutify.getActiveBlock().curves[5].colorCurve;

        curveR.points = [];
        curveG.points = [];
        curveB.points = [];

        if (tintValue < 0) {
            curveR.points.push({ x: 0.0, y: 0.0 });
            curveR.points.push({ x: 1.0, y: 1 + tintValue * 0.1372 });

            curveG.points.push({ x: 0.0, y: 0.0 });
            curveG.points.push({ x: 0.9523, y: 0.9523 - tintValue * 0.047 });
            curveG.points.push({ x: 1.0, y: 1.0 });

            curveB.points.push({ x: 0.0, y: 0.0 });
            curveB.points.push({ x: 1.0, y: 1 + tintValue * 0.10588 });
        } else if (tintValue >= 0) {
            curveR.points.push({ x: 0.0, y: 0.0 });
            curveR.points.push({ x: 1.0 - tintValue * 0.12156, y: 1.0 });

            curveG.points.push({ x: 0.0, y: 0.0 });
            curveG.points.push({ x: 1.0, y: 1.0 - tintValue * 0.05882 });

            curveB.points.push({ x: 0.0, y: 0.0 });
            curveB.points.push({ x: 1.0 - tintValue * 0.09019, y: 1.0 });
        }

        curveR.draw();
        curveG.draw();
        curveB.draw();
        curveR.updateValues();
        curveG.updateValues();
        curveB.updateValues();

        let curveTexture = gpu.RGBPointsToCurve(curveR.rgb, curveG.rgb, curveB.rgb);
        lutify.getActiveBlock().passes[this.passNamesList.indexOf('TINT')].uniforms["map"].value = curveTexture;
        gpu.render();
    }

    async predictAll() {
        const imageElement = await this.getSourceImage();

        for await (const [key, model] of this.models.entries()) {
            const { lutFile, lutContent } = await this.predict(model.file, imageElement)
            lutify.getActiveBlock().predictions[key] = lutFile
            lutify.getActiveBlock().predictionsContent[key] = lutContent
        }
    }

    async getSourceImage() {
        let blockNum = blocks.getBlockIndex_byBlockNum(lutify.getActiveBlock().blockNum)
        let passes = blocks.getAllPassesToBlock(blockNum)

        // check the image size for when using larged media sizes
        let imageURL = lutify.getIDTLMTimage(passes) // getting the main canvas image with IDT LMT

        let imageElement = new Image()
        imageElement.src = imageURL
        await imageElement.decode()
        return imageElement
    }

    async applyPredictions(predictionsContent) {
        for await (const [key, predictionContent] of Object.entries(predictionsContent)) {
            let LUTFile = new File([predictionContent], 'neural-tone-ai.cube', { type: 'text/plain' })
            let loadedLUTs = await luts.load([LUTFile])
            lutify.getActiveBlock().predictions[key] = loadedLUTs[0]
            lutify.getActiveBlock().predictionsContent[key] = predictionContent
        }
    }

    addPasses() {
        let shaderPass_exposure = gpu.createLiftGammaGainPass();
        let shaderPass_contrast = gpu.createLiftGammaGainPass();
        let shaderPass_wb = gpu.createCurveShaderPass('white balance')
        let shaderPass_tint = gpu.createCurveShaderPass('tint')
        let AIPass = gpu.createRenderPass()
        let LUTPass = gpu.createRenderPass()

        gpu.addPassToComposer(shaderPass_exposure, 'toMiddle')
        gpu.addPassToComposer(shaderPass_contrast, 'toMiddle')
        gpu.addPassToComposer(shaderPass_wb, 'toMiddle')
        gpu.addPassToComposer(shaderPass_tint, 'toMiddle')
        gpu.addPassToComposer(AIPass, 'toMiddle')
        gpu.addPassToComposer(LUTPass, 'toMiddle')

        return [shaderPass_exposure, shaderPass_contrast, shaderPass_wb, shaderPass_tint, AIPass, LUTPass]
    }

    async loadModel(toolName = 'NeuralToneAI') {
        if (this.models.some(model => model.file)) return
        if (vm.$store.state.UI.neuralToneAI.isDownloading) return;

        let storeData = await this.isModelDownloaded()

        if (!storeData) {
            vm.$store.dispatch('UI/setNeuralToneAIDownloading', true)

            let response = await vm.$store.dispatch('Projects/fetchSystemFiles', {
                block: 'neural-tone-ai'
            })

            let progress = []
            let promises = []

            response.forEach((file, idx) => {
                promises.push(
                    vm.$store.dispatch('Files/fetchFromS3', {
                        url: file.presignedURL,
                        config: {
                            responseType: 'blob',
                            onDownloadProgress: progressEvent => {
                                progress[idx] = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                            }
                        }
                    })
                )
            })

            let interval = setInterval(async () => {
                if (!progress.length) return
                let totalProgress = progress.reduce((r, i) => (r + i)) / promises.length

                if (totalProgress >= 100) {
                    clearInterval(interval)
                    // vm.$snackbar(`AI model downloaded. You may now use the ${toolName} tool.`, 'success');
                }

                vm.$store.dispatch('UI/setNeuralToneAIDownloadProgress', totalProgress.toFixed())
            }, 50)

            let files = await Promise.all(promises)

            storeData = {
                Mystera: {
                    model: new File([files[0]], response[0].name),
                    weights: [
                        new File([files[1]], response[1].name),
                        new File([files[2]], response[2].name),
                    ]
                },
                Chromia: {
                    model: new File([files[3]], response[3].name),
                    weights: [
                        new File([files[4]], response[4].name),
                        new File([files[5]], response[5].name),
                    ]
                },
                Mythra: {
                    model: new File([files[6]], response[6].name),
                    weights: [
                        new File([files[7]], response[7].name),
                        new File([files[8]], response[8].name),
                    ]
                },
                Seraphine: {
                    model: new File([files[9]], response[9].name),
                    weights: [
                        new File([files[10]], response[10].name),
                        new File([files[11]], response[11].name),
                    ]
                },
            }

            vm.$store.dispatch('UI/setNeuralToneAIDownloading', false)
            await window.blocksStore.setItem('NeuralToneAI', storeData)
        }

        this.models[0].file = await tf.loadLayersModel(
            tf.io.browserFiles([
                storeData.Chromia.model,
                storeData.Chromia.weights[0],
                storeData.Chromia.weights[1]
            ])
        )

        this.models[1].file = await tf.loadLayersModel(
            tf.io.browserFiles([
                storeData.Mystera.model,
                storeData.Mystera.weights[0],
                storeData.Mystera.weights[1]
            ])
        )

        this.models[2].file = await tf.loadLayersModel(
            tf.io.browserFiles([
                storeData.Chromia.model,
                storeData.Chromia.weights[0],
                storeData.Chromia.weights[1]
            ])
        )

        this.models[3].file = await tf.loadLayersModel(
            tf.io.browserFiles([
                storeData.Mystera.model,
                storeData.Mystera.weights[0],
                storeData.Mystera.weights[1]
            ])
        )

        this.models[4].file = await tf.loadLayersModel(
            tf.io.browserFiles([
                storeData.Mythra.model,
                storeData.Mythra.weights[0],
                storeData.Mythra.weights[1]
            ])
        )

        this.models[5].file = await tf.loadLayersModel(
            tf.io.browserFiles([
                storeData.Mythra.model,
                storeData.Mythra.weights[0],
                storeData.Mythra.weights[1]
            ])
        )

        this.models[6].file = await tf.loadLayersModel(
            tf.io.browserFiles([
                storeData.Seraphine.model,
                storeData.Seraphine.weights[0],
                storeData.Seraphine.weights[1]
            ])
        )

        this.models[7].file = await tf.loadLayersModel(
            tf.io.browserFiles([
                storeData.Seraphine.model,
                storeData.Seraphine.weights[0],
                storeData.Seraphine.weights[1]
            ])
        )
    }

    async loadLuts() {
        if (luts['LUTcontrols']['NeuralToneAI']) return
        // vm.$store.dispatch("Loader/showProgressBar", "indeterminate");

        let data = {
            control: 'LUTcontrols',
            category: 'NeuralToneAI'
        }

        await _Adjustments.LUTcontrols.load(data)

        luts['LUTcontrols']['NeuralToneAI'].forEach((preset, index) => {
            preset.presetId = index
        })

        UI.getActiveBlock().click()
    }

    async onPresetSelection(preset = false) {
        if (!lutify.getActiveBlock()) return

        const $block = $(UI.getActiveBlock())

        await new Promise(resolve => {
            setTimeout(() => {
                resolve()
            }, 500)
        })

        if (preset) {
            let imageURL = lutify.getIDTLMTimage([...gpu.composer.passes], true, false) // getting the main canvas image with ALL PASSES
            let imageElement = new Image()
            imageElement.src = imageURL
            await imageElement.decode()

            $block.find('.sample-selector img').remove()
            $block.find('.sample-selector .select-asset-btn').addClass('hide')
            $block.find('.sample-selector').prepend(imageElement)
            $block.find('.sample-selector .name').text(`Selected AI Model: ${preset.title}`)
        } else {
            $block.find('.sample-selector img').remove()
            $block.find('.sample-selector .select-asset-btn').removeClass('hide')
            $block.find('.sample-selector .name').text(``)
        }
    }

    showPreviews() {
        lutify.selectedPreviewCategory = 'NeuralToneAI'

        UI.togglePreviewsContainer()
        UI.updatePreviewsTab('NeuralToneAI')
        lutPreviewer.switchCanvases('NeuralToneAI')

        lutPreviewer.cloneMainComposerPasses()
        lutPreviewer.addPass('LUTcontrols', 'NeuralToneAI', 5, lutify.getActiveBlock().blendingMode, 'NeuralToneAI')

        if (lutify.getActiveBlock().presetId) {
            let preset = luts['LUTcontrols']['NeuralToneAI'][lutify.getActiveBlock().presetId]
            UI.updateSelectedPreview(preset.composerIndex)
        } else {
            // UI.scrollToSelectedPreview()
            UI.updateSelectedPreview()
        }

        vm.$nextTick(() => {
            lutPreviewer.render()
        })
    }

    async predict(model, imageElement) {
        let tensor = tf.browser.fromPixels(imageElement)

        tensor = tf.cast(tensor, 'float32')
        tensor = this.resize(tensor, this.img_size)
        let image = this.normalize(tensor)

        let image_reshaped = tf.reshape(image, [1, this.img_size, this.img_size, 3])
        let target = await model.apply(image_reshaped, { 'training': true })
        let LUT = await this.img_to_lut(image, tf.squeeze(target))
        let [r, g, b] = this.split_channels(LUT, 3, 1)

        let text = 'TITLE Created with fylm.ai NeuralToneAI\n'
        text = text + 'LUT_3D_SIZE 8\n\n'
        for (let i = 0; i < this.lut_size * this.lut_size * this.lut_size; i++) {
            text = text + r[i].toFixed(6).toString() + ' ' + g[i].toFixed(6).toString() + ' ' + b[i].toFixed(6).toString() + '\n'
        }

        let LUTFile = new File([text], 'neural-tone-ai.cube', { type: 'text/plain' })
        let loadedLUTs = await luts.load([LUTFile])
        return {
            lutFile: loadedLUTs[0],
            lutContent: text
        }
    }

    apply(LUT) {
        let pass = gpu.createLUTPass(LUT.texture)
        pass.uid = lutify.getActiveBlock().passes[4].uid
        let index = gpu.getPassIndexById(lutify.getActiveBlock().passes[4].uid)
        gpu.composer.passes[index] = pass
        lutify.getActiveBlock().passes[4] = pass
        this.resetOpacity()
        gpu.render()
    }

    resize(input_image, size) {
        let output_image = tf.image.resizeNearestNeighbor(input_image, [size, size])
        return output_image
    }

    normalize(input_image) {
        let output_image = tf.sub(tf.div(input_image, 127.5), 1)
        return output_image
    }

    async img_to_lut(input_image, target_image) {
        let target = tf.add(tf.mul(target_image, 0.5), 0.5)
        let input = tf.add(tf.mul(input_image, 0.5), 0.5)

        let t = tf.sub(target, input)
        let [tR, tG, tB] = this.split_channels(t, 3, 2)

        let [iR, iG, iB] = this.split_channels(input, 3, 2)
        let icolor = tf.stack([iR, iG, iB]).transpose()

        let a = this.lut_size - 1
        let LUT = []
        for (let k = 0; k < this.lut_size; k++) {
            for (let j = 0; j < this.lut_size; j++) {
                for (let i = 0; i < this.lut_size; i++) {
                    LUT.push([i / a, j / a, k / a])
                }
            }
        }

        LUT = tf.stack(LUT)

        let interpolation = new KNeighborsRegressor(40, 'distance')
        await interpolation.fit(icolor, tR)
        let tRp = interpolation.predict(LUT)

        await interpolation.fit(icolor, tG)
        let tGp = interpolation.predict(LUT)

        await interpolation.fit(icolor, tB)
        let tBp = interpolation.predict(LUT)

        let [lutiR, lutiG, lutiB] = this.split_channels(LUT, 3, 1)
        lutiR = tf.add(lutiR, tRp)
        lutiG = tf.add(lutiG, tGp)
        lutiB = tf.add(lutiB, tBp)
        LUT = tf.stack([lutiR, lutiG, lutiB]).transpose()

        LUT = await tf.clipByValue(LUT, 0, 1)
        return LUT
    }

    split_channels(tensor, num_splits, axis) {
        let [tR, tG, tB] = tf.split(tensor, num_splits, axis)
        tR = tR.dataSync()
        tG = tG.dataSync()
        tB = tB.dataSync()
        return [tR, tG, tB]
    }

    async resetBlock($element) {
        lutify.getActiveBlock().presetId = null

        this.resetOpacity()

        $element.find('.exposure_range').val(0)
        $element.find('.exposure_range').trigger('change')

        $element.find('.contrast_range').val(0)
        $element.find('.contrast_range').trigger('change')

        $element.find('.white_balance_range').val(0)
        $element.find('.white_balance_range').trigger('change')

        $element.find('.tint_range').val(0)
        $element.find('.tint_range').trigger('change')

        await this.predictAll()
        this.onPresetSelection()
        UI.deselectPreview()

        $element.find('.blending-mode__items-container > span[data-id="0"]').trigger('click')

        let AIPass = gpu.createRenderPass()
        AIPass.uid = lutify.getActiveBlock().passes[4].uid
        let LUTPass = gpu.createRenderPass()
        LUTPass.uid = lutify.getActiveBlock().passes[5].uid

        lutify.getActiveBlock().passes[4] = AIPass
        lutify.getActiveBlock().passes[5] = LUTPass

        gpu.composer.passes[gpu.getPassIndexById(AIPass.uid)] = AIPass
        gpu.composer.passes[gpu.getPassIndexById(LUTPass.uid)] = LUTPass

        // lutify.getActiveBlock().passes.forEach(pass => pass.enabled = false);
        gpu.render()
        lutPreviewer.render()
    }

    resetOpacity() {
        $(UI.getActiveBlock()).find('.opacity-input').val(100)
        $(UI.getActiveBlock()).find('.opacity-input').trigger('change')
    }

    opacitySliderHandler($element) {
        let opacityValue = $element.find('.opacity_slider').val()
        let calcOpacityValue = opacityValue * 0.01

        $element.find('.opacity-input').val(opacityValue)

        lutify.getActiveBlock().opacity = opacityValue
        lutify.getActiveBlock().passes[4].uniforms.opacity.value = calcOpacityValue
        lutify.getActiveBlock().passes[5].uniforms.opacity.value = calcOpacityValue

        lutPreviewer.updateOpacity(calcOpacityValue, 4);
        lutPreviewer.updateOpacity(calcOpacityValue, 5);
        UI.setPreviewerOpacity(lutify.getActiveBlock().opacity);

        gpu.render();
        lutPreviewer.render();
    }

    opacityInputHandler($element) {
        let opacityValue = $element.find('.opacity-input').val()
        let opacitySlider = $element.find('.opacity_slider')

        if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue
        if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue

        opacitySlider.val(opacityValue)
        opacitySlider.trigger('input')
    }

    async isModelDownloaded() {
        let storeData = await window.blocksStore.getItem('NeuralToneAI')
        return storeData
    }

    addRegenerateButton($element) {
        let icon = document.createElement('i')
        icon.setAttribute('class', 'btn-block-regenerate material-icons')
        icon.setAttribute('data-tippy-content', 'Regenerate')
        icon.innerHTML = 'loop'
        icon.addEventListener('click', async () => {
            UI.appendBlockLoadingSpinner($element)

            await this.predictAll()
            this.showPreviews()

            if (!lutify.getActiveBlock().presetId) {
                UI.removeBlockLoadingSpinner($element)
                return;
            }

            const AIPass = gpu.createLUTPass(lutify.getActiveBlock().predictions[lutify.getActiveBlock().presetId].texture)
            AIPass.name = 'NeuralToneAI model LUT'
            AIPass.uid = lutify.getActiveBlock().passes[4].uid

            lutify.getActiveBlock().passes[4] = AIPass
            gpu.composer.passes[gpu.getPassIndexById(AIPass.uid)] = AIPass

            UI.removeBlockLoadingSpinner($element)

            gpu.render()
            $element.trigger('click')

        })
        $element.find('.header-container .controls-wrapper').prepend(icon)
    }

    async applyChanges($block, values, blockData) {
        UI.setAdjustmentBlock_rangeValue($block, values.exposure, 0);
        UI.setAdjustmentBlock_rangeValue($block, values.contrast, 1);
        UI.setAdjustmentBlock_rangeValue($block, values.whiteBalance, 2);
        UI.setAdjustmentBlock_rangeValue($block, values.tint * this.tint.calcValue, 3);

        $block.find(".exposure_range").trigger("change");
        $block.find(".contrast_range").trigger("change");
        $block.find(".white_balance_range").trigger("change");
        $block.find(".tint_range").trigger("change");

        if (blockData.presetId) {
            let $preview = $(`#previews-list-container .list-item[data-category="NeuralToneAI"][data-preset-id="${blockData.presetId}"]`)

            lutPreviewer.onColourMatchPreviewSelection($preview)

            let preset = luts['LUTcontrols']['NeuralToneAI'][blockData.presetId]
            lutify.getActiveBlock().presetId = blockData.presetId
            this.onPresetSelection(preset)

            window.lutify.getActiveBlock().collapsedPreviews = blockData.collapsedPreviews;

            $block.find('.opacity-input').val(parseInt(blockData.opacity))
            $block.find('.opacity-input').trigger('change')
        }
    }
}
